/* eslint-disable max-len */
import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_PAYMENTS_LIST = gql`
query getAdminPayments($active: Boolean, $payed: Boolean, $renewSubscription: Boolean, $couponCode: String, $couponTypeId: String, $userId: String, $email: String, $name: String, $country: String, $present: Boolean, $productSlugName: String, $subscriptionStatus: String, $productGroup: String, $productType: String, $provider: String, $startDate: String, $finishDate: String, $from: Int, $to: Int, $sortingField: String, $sortingType: Int, $getTotal: Boolean) {
  getAdminPayments(active: $active, payed: $payed, renewSubscription: $renewSubscription, couponCode: $couponCode, couponTypeId: $couponTypeId, userId: $userId, email: $email, name: $name, country: $country, present: $present, productSlugName: $productSlugName, subscriptionStatus: $subscriptionStatus, productGroup: $productGroup, productType: $productType, provider: $provider, startDate: $startDate, finishDate: $finishDate, from: $from, to: $to, sortingField: $sortingField, sortingType: $sortingType, getTotal: $getTotal) {
      isAuth
      total
      query
      payments {
        _id
        user
        email
        emailAtProvider
        name
        idNumber
        surname
        country
        productSlugName
        subscriptionRenewalProductSlugName
        contractType
        productGroup
        subscriptionLastDate
        renewSubscription
        provider
        transactionId
        payed
        amount
        datePayment
        numRenewedSubscriptions
        subscriptionFailedRenewalCounter
        originPost
        registrationDate
        couponCode
        subscriptionRenewalLastError {
          date
          code
          message
        }
      }
    }
  }
`;
// payments {
//   user
//   email
//   productSlugName
//   subscriptionRenewalProductSlugName
//   contractType
//   productGroup
//   subscriptionLastDate
//   renewSubscription
//   provider
//   payed
//   datePayment
//   presentData {
//     presentSenderName
//     presentDestinationName
//     presentDestinationEmail
//     presentDeliveryDate
//     presentMessage
//     couponCode
//     presentGivenProductSlugName
//     presentSentDate      
//   }
// }


const getPaymentsList = async (variables) => {
  try {
    const result = await client.query({
      query: GET_PAYMENTS_LIST,
      variables,
      errorPolicy: 'all',
      fetchResults: true,
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { getAdminPayments: paymentsListData } } = result;

    if (paymentsListData) {
      return paymentsListData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getPaymentsList = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getPaymentsList Error: ${error}`);
    return null;
  }
};

export default getPaymentsList;
